import { Product } from './types';

export const mockProduct: Product = {
  id: 1,
  image: 'https://placeholder.pagebee.io/api/plain/220/220',
  alt: '',
  title: 'Atoderm Масло для душа',
  subtitle: 'Экзема',
  labels: [{ name: 'Выгода 20%', color: 'orange' }],
  brandLabels: [
    {
      color: '#0077CF',
      name: 'atoderm',
      url: '/atoderm'
    }
  ],
  prices: {
    price: 4800,
    oldPrice: 6000
  }
};
